export interface FileExporterTableMetadata {
	tableName: string;
	title: string;
	isParent: boolean;
}
